import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "hr-page crawl-page" }
const _hoisted_2 = { class: "console-page-head" }
const _hoisted_3 = { class: "console-head-side crawl-header-actions" }
const _hoisted_4 = { class: "hr-body" }
const _hoisted_5 = { class: "hr-main-layout" }
const _hoisted_6 = { class: "section-card distribution-section" }
const _hoisted_7 = { class: "section-header" }
const _hoisted_8 = { class: "section-header-left" }
const _hoisted_9 = { class: "section-body distribution-body" }
const _hoisted_10 = { class: "dist-summary-row" }
const _hoisted_11 = { class: "dist-summary-item" }
const _hoisted_12 = { class: "dist-summary-value" }
const _hoisted_13 = { class: "dist-summary-item" }
const _hoisted_14 = { class: "dist-summary-value" }
const _hoisted_15 = { class: "dist-summary-item" }
const _hoisted_16 = { class: "dist-summary-value" }
const _hoisted_17 = { class: "dist-biz-section dist-biz-section--compact" }
const _hoisted_18 = { class: "dist-biz-compact-row" }
const _hoisted_19 = ["onClick"]
const _hoisted_20 = { class: "dist-biz-name" }
const _hoisted_21 = { class: "dist-biz-count" }
const _hoisted_22 = {
  key: 0,
  class: "dist-filter-hint"
}
const _hoisted_23 = { class: "dist-matrix-section" }
const _hoisted_24 = { class: "dist-matrix-head" }
const _hoisted_25 = { class: "dist-matrix-hint" }
const _hoisted_26 = { class: "dist-matrix-wrap" }
const _hoisted_27 = { class: "dist-matrix-table" }
const _hoisted_28 = ["onClick"]
const _hoisted_29 = { class: "col-region sticky-col region-sido" }
const _hoisted_30 = { class: "region-label" }
const _hoisted_31 = { class: "col-total num-cell" }
const _hoisted_32 = { class: "cell-num" }
const _hoisted_33 = { class: "cell-pct" }
const _hoisted_34 = { class: "cell-num" }
const _hoisted_35 = {
  key: 0,
  class: "cell-pct"
}
const _hoisted_36 = ["onClick"]
const _hoisted_37 = { class: "col-region sticky-col sigungu-name" }
const _hoisted_38 = { class: "region-label" }
const _hoisted_39 = { class: "col-total num-cell" }
const _hoisted_40 = { class: "cell-num" }
const _hoisted_41 = { class: "cell-pct" }
const _hoisted_42 = { class: "cell-num" }
const _hoisted_43 = {
  key: 0,
  class: "cell-pct"
}
const _hoisted_44 = {
  key: 0,
  class: "dist-empty-row"
}
const _hoisted_45 = ["colspan"]
const _hoisted_46 = { key: 0 }
const _hoisted_47 = { class: "dist-total-row" }
const _hoisted_48 = { class: "col-total num-cell" }
const _hoisted_49 = { class: "cell-num" }
const _hoisted_50 = { class: "cell-num" }
const _hoisted_51 = { class: "guide-header" }
const _hoisted_52 = { class: "guide-body" }
const _hoisted_53 = { class: "command-builder" }
const _hoisted_54 = { class: "builder-title" }
const _hoisted_55 = { class: "generated-command" }
const _hoisted_56 = { class: "command-label-row" }
const _hoisted_57 = { class: "label" }
const _hoisted_58 = { class: "command-box" }
const _hoisted_59 = {
  class: "sido-all-desc",
  style: {"margin-top":"12px"}
}
const _hoisted_60 = { class: "command-examples" }
const _hoisted_61 = { class: "examples-title" }
const _hoisted_62 = { class: "example-main" }
const _hoisted_63 = { class: "example-desc" }
const _hoisted_64 = { class: "install-guide" }
const _hoisted_65 = { class: "guide-steps" }
const _hoisted_66 = { class: "guide-step" }
const _hoisted_67 = { class: "step-info" }
const _hoisted_68 = { class: "step-desc" }
const _hoisted_69 = { class: "inline-command" }
const _hoisted_70 = { class: "guide-footer" }

import { ref, onMounted, computed } from 'vue';
import { crawlApi } from '@/services/api';
import { useStore } from 'vuex';
import LoadingOverlay from '@/components/common/LoadingOverlay.vue';
import CrawlExcelDownloadDialog from '@/components/crawl/CrawlExcelDownloadDialog.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'CrawlPage',
  setup(__props) {

const store = useStore();

// 상태
const stats = ref<any>({ summary: {}, byRegion: [], byBiz: [], bySigungu: [], bizTypes: [] });
const statsLoading = ref(false);
const selectedBiz = ref('');
const expandedSido = ref('');
const sidoOptions = ref<any[]>([]);

/** PC 크롤러 압축 파일 다운로드 */
const downloadPcCrawler = () => {
  const link = document.createElement('a');
  link.href = '/local-crawler.zip';
  link.download = 'local-crawler.zip';
  link.rel = 'noopener';
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};

// PC 크롤러 가이드 모달
const crawlerGuideDialog = ref(false);
const showInstallGuide = ref(false);

const commandExamples = [
  { cmd: '실행.bat', desc: '더블클릭. 전국 한 바퀴, 최근 일주일은 건너뛰고 이어서 수집' },
  { cmd: 'node crawl.js --loop', desc: '고급: 한 바퀴 후에도 계속 반복' },
];

const visibleBizTypes = computed(() => stats.value.bizTypes || []);

const sigunguBySido = computed(() => {
  const map: Record<string, any[]> = {};
  (stats.value.bySigungu || []).forEach((sg: any) => {
    if (!map[sg.sido_code]) map[sg.sido_code] = [];
    map[sg.sido_code].push(sg);
  });
  Object.values(map).forEach(arr => {
    arr.sort((a, b) => String(a.sigungu_name).localeCompare(String(b.sigungu_name), 'ko'));
  });
  return map;
});

const getSigunguRows = (sidoCode: string) => sigunguBySido.value[sidoCode] || [];

const getSharePct = (part: number | undefined, whole: number | undefined) => {
  if (!part || !whole) return '';
  return `${((part / whole) * 100).toFixed(1)}%`;
};

const formatBizCount = (count: number | undefined) => {
  if (!count) return '-';
  return count.toLocaleString();
};

const getBizTotal = (bizShort: string) => {
  const item = (stats.value.byBiz || []).find((b: any) => b.biz_short === bizShort);
  return item?.count || 0;
};

const toggleBizFilter = (bizShort: string) => {
  selectedBiz.value = selectedBiz.value === bizShort ? '' : bizShort;
};

const toggleSidoExpand = (sidoCode: string) => {
  expandedSido.value = expandedSido.value === sidoCode ? '' : sidoCode;
};

/** 시군구 클릭 → 시설검색 새 창 (사업구분 필터 없음 · 전체) */
const openSigunguSearch = (sg: any, sidoName: string) => {
  const params = new URLSearchParams();
  params.set('sido', String(sg.sido_code));
  params.set('sigungu', String(sg.sigungu_code));
  params.set('label', `${sidoName} ${sg.sigungu_name}`);

  const url = `/facility?${params.toString()}`;
  const width = 1200;
  const height = 820;
  const left = Math.max(0, Math.floor((window.screen.width - width) / 2));
  const top = Math.max(0, Math.floor((window.screen.height - height) / 2));
  const features = `width=${width},height=${height},left=${left},top=${top},menubar=no,toolbar=no,location=yes,status=no,resizable=yes,scrollbars=yes`;

  const win = window.open(url, 'facilitySearchByRegion', features);
  win?.focus();
};

const excelDialogOpen = ref(false);

// 데이터 조회
const fetchData = async () => {
  try {
    statsLoading.value = true;
    const [statsRes, sidoRes] = await Promise.all([
      crawlApi.getStats(),
      crawlApi.getSidoList()
    ]);

    if (statsRes.data.success) {
      stats.value = statsRes.data.data;
    }

    if (sidoRes.data.success) {
      sidoOptions.value = sidoRes.data.data;
    }
  } catch (error) {
    console.error('데이터 조회 오류:', error);
    store.commit('showSnackbar', { text: '통계 조회 실패', color: 'error' });
  } finally {
    statsLoading.value = false;
  }
};

// 명령어 복사
const copyCommand = async (command: string) => {
  try {
    await navigator.clipboard.writeText(command);
    store.commit('showSnackbar', { text: '명령어가 복사되었습니다.', color: 'success' });
  } catch (err) {
    store.commit('showSnackbar', { text: '복사 실패', color: 'error' });
  }
};

// 마운트
onMounted(async () => {
  await fetchData();
});

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_expand_transition = _resolveComponent("v-expand-transition")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_dialog = _resolveComponent("v-dialog")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("header", _hoisted_2, [
      _cache[15] || (_cache[15] = _createElementVNode("div", { class: "console-page-copy" }, [
        _createElementVNode("p", { class: "console-kicker" }, "데이터"),
        _createElementVNode("h2", { class: "console-title" }, "크롤링 관리")
      ], -1)),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_v_btn, {
          variant: "flat",
          class: "action-btn btn-save",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (excelDialogOpen.value = true))
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_icon, {
              class: "mr-1",
              size: "18"
            }, {
              default: _withCtx(() => [...(_cache[9] || (_cache[9] = [
                _createTextVNode("mdi-microsoft-excel", -1)
              ]))]),
              _: 1
            }),
            _cache[10] || (_cache[10] = _createTextVNode(" 엑셀 다운로드 ", -1))
          ]),
          _: 1
        }),
        _createVNode(_component_v_btn, {
          variant: "flat",
          class: "action-btn btn-download",
          onClick: downloadPcCrawler
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_icon, {
              class: "mr-1",
              size: "18"
            }, {
              default: _withCtx(() => [...(_cache[11] || (_cache[11] = [
                _createTextVNode("mdi-download", -1)
              ]))]),
              _: 1
            }),
            _cache[12] || (_cache[12] = _createTextVNode(" PC 크롤러 ", -1))
          ]),
          _: 1
        }),
        _createVNode(_component_v_btn, {
          variant: "flat",
          class: "action-btn btn-guide",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (crawlerGuideDialog.value = true))
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_icon, {
              class: "mr-1",
              size: "18"
            }, {
              default: _withCtx(() => [...(_cache[13] || (_cache[13] = [
                _createTextVNode("mdi-help-circle-outline", -1)
              ]))]),
              _: 1
            }),
            _cache[14] || (_cache[14] = _createTextVNode(" 사용법 ", -1))
          ]),
          _: 1
        })
      ])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _createVNode(_component_v_icon, {
                size: "20",
                class: "mr-2"
              }, {
                default: _withCtx(() => [...(_cache[16] || (_cache[16] = [
                  _createTextVNode("mdi-chart-tree", -1)
                ]))]),
                _: 1
              }),
              _cache[17] || (_cache[17] = _createTextVNode(" 기관 분포 현황 ", -1))
            ]),
            _cache[18] || (_cache[18] = _createElementVNode("span", { class: "distribution-note" }, "복수 사업 기관은 사업구분별 중복 집계", -1))
          ]),
          _createElementVNode("div", _hoisted_9, [
            _createVNode(LoadingOverlay, {
              show: statsLoading.value,
              text: "통계 불러오는 중..."
            }, null, 8, ["show"]),
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("div", _hoisted_11, [
                _cache[19] || (_cache[19] = _createElementVNode("span", { class: "dist-summary-label" }, "총 기관", -1)),
                _createElementVNode("span", _hoisted_12, _toDisplayString(stats.value.summary?.total_count?.toLocaleString() || 0), 1)
              ]),
              _createElementVNode("div", _hoisted_13, [
                _cache[20] || (_cache[20] = _createElementVNode("span", { class: "dist-summary-label" }, "시도", -1)),
                _createElementVNode("span", _hoisted_14, _toDisplayString(stats.value.summary?.sido_count || 0), 1)
              ]),
              _createElementVNode("div", _hoisted_15, [
                _cache[21] || (_cache[21] = _createElementVNode("span", { class: "dist-summary-label" }, "시군구", -1)),
                _createElementVNode("span", _hoisted_16, _toDisplayString(stats.value.summary?.sigungu_count || 0), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_17, [
              _cache[24] || (_cache[24] = _createElementVNode("div", { class: "dist-subtitle dist-subtitle--compact" }, "사업구분별 기관 수", -1)),
              _createElementVNode("div", _hoisted_18, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(stats.value.byBiz, (biz) => {
                  return (_openBlock(), _createElementBlock("button", {
                    key: biz.biz_short,
                    type: "button",
                    class: _normalizeClass(["dist-biz-chip", { active: selectedBiz.value === biz.biz_short }]),
                    onClick: ($event: any) => (toggleBizFilter(biz.biz_short))
                  }, [
                    _createElementVNode("span", {
                      class: "dist-biz-dot",
                      style: _normalizeStyle({ background: biz.biz_color })
                    }, null, 4),
                    _createElementVNode("span", _hoisted_20, _toDisplayString(biz.biz_short), 1),
                    _createElementVNode("span", _hoisted_21, _toDisplayString(biz.count?.toLocaleString() || 0), 1)
                  ], 10, _hoisted_19))
                }), 128))
              ]),
              (selectedBiz.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                    _createVNode(_component_v_icon, {
                      size: "14",
                      class: "mr-1"
                    }, {
                      default: _withCtx(() => [...(_cache[22] || (_cache[22] = [
                        _createTextVNode("mdi-filter", -1)
                      ]))]),
                      _: 1
                    }),
                    _createTextVNode(" " + _toDisplayString(selectedBiz.value) + " 강조 중 ", 1),
                    _createVNode(_component_v_btn, {
                      variant: "text",
                      size: "x-small",
                      class: "btn-filter-clear",
                      onClick: _cache[2] || (_cache[2] = ($event: any) => (selectedBiz.value = ''))
                    }, {
                      default: _withCtx(() => [...(_cache[23] || (_cache[23] = [
                        _createTextVNode("해제", -1)
                      ]))]),
                      _: 1
                    })
                  ]))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_23, [
              _createElementVNode("div", _hoisted_24, [
                _cache[27] || (_cache[27] = _createElementVNode("div", { class: "dist-subtitle" }, "지역별 · 사업구분별 분포", -1)),
                _createElementVNode("span", _hoisted_25, [
                  _createVNode(_component_v_icon, {
                    size: "14",
                    class: "mr-1"
                  }, {
                    default: _withCtx(() => [...(_cache[25] || (_cache[25] = [
                      _createTextVNode("mdi-open-in-new", -1)
                    ]))]),
                    _: 1
                  }),
                  _cache[26] || (_cache[26] = _createTextVNode(" 시군구 클릭 → 해당 지역 기관 목록 (새 창 · 사업구분 전체) ", -1))
                ])
              ]),
              _createElementVNode("div", _hoisted_26, [
                _createElementVNode("table", _hoisted_27, [
                  _createElementVNode("colgroup", null, [
                    _cache[28] || (_cache[28] = _createElementVNode("col", { class: "col-w-region" }, null, -1)),
                    _cache[29] || (_cache[29] = _createElementVNode("col", { class: "col-w-total" }, null, -1)),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(visibleBizTypes.value, (biz) => {
                      return (_openBlock(), _createElementBlock("col", {
                        key: `col-${biz.short}`,
                        class: "col-w-biz"
                      }))
                    }), 128))
                  ]),
                  _createElementVNode("thead", null, [
                    _createElementVNode("tr", null, [
                      _cache[30] || (_cache[30] = _createElementVNode("th", { class: "col-region sticky-col" }, "지역", -1)),
                      _cache[31] || (_cache[31] = _createElementVNode("th", { class: "col-total" }, "합계", -1)),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(visibleBizTypes.value, (biz) => {
                        return (_openBlock(), _createElementBlock("th", {
                          key: biz.short,
                          class: _normalizeClass(["col-biz", { highlighted: selectedBiz.value === biz.short }])
                        }, [
                          _createElementVNode("span", {
                            class: "th-dot",
                            style: _normalizeStyle({ background: biz.color })
                          }, null, 4),
                          _createTextVNode(" " + _toDisplayString(biz.short), 1)
                        ], 2))
                      }), 128))
                    ])
                  ]),
                  _createElementVNode("tbody", null, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(stats.value.byRegion, (region) => {
                      return (_openBlock(), _createElementBlock(_Fragment, {
                        key: region.sido_code
                      }, [
                        _createElementVNode("tr", {
                          class: _normalizeClass(["dist-region-row", { expanded: expandedSido.value === region.sido_code }]),
                          onClick: ($event: any) => (toggleSidoExpand(region.sido_code))
                        }, [
                          _createElementVNode("td", _hoisted_29, [
                            _createVNode(_component_v_icon, {
                              size: "16",
                              class: "expand-icon"
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(expandedSido.value === region.sido_code ? 'mdi-chevron-down' : 'mdi-chevron-right'), 1)
                              ]),
                              _: 2
                            }, 1024),
                            _createElementVNode("span", _hoisted_30, _toDisplayString(region.sido_name), 1)
                          ]),
                          _createElementVNode("td", _hoisted_31, [
                            _createElementVNode("span", _hoisted_32, _toDisplayString(region.total_count?.toLocaleString()), 1),
                            _createElementVNode("span", _hoisted_33, _toDisplayString(getSharePct(region.total_count, stats.value.summary?.total_count)), 1)
                          ]),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(visibleBizTypes.value, (biz) => {
                            return (_openBlock(), _createElementBlock("td", {
                              key: `${region.sido_code}-${biz.short}`,
                              class: _normalizeClass(["col-biz num-cell", { highlighted: selectedBiz.value === biz.short, dimmed: selectedBiz.value && selectedBiz.value !== biz.short, 'has-value': region.biz?.[biz.short] }])
                            }, [
                              _createElementVNode("span", _hoisted_34, _toDisplayString(formatBizCount(region.biz?.[biz.short])), 1),
                              (region.biz?.[biz.short])
                                ? (_openBlock(), _createElementBlock("span", _hoisted_35, _toDisplayString(getSharePct(region.biz[biz.short], region.total_count)), 1))
                                : _createCommentVNode("", true)
                            ], 2))
                          }), 128))
                        ], 10, _hoisted_28),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(getSigunguRows(region.sido_code), (sg) => {
                          return _withDirectives((_openBlock(), _createElementBlock("tr", {
                            key: `${region.sido_code}-${sg.sigungu_code}`,
                            class: "dist-sigungu-row",
                            onClick: ($event: any) => (openSigunguSearch(sg, region.sido_name))
                          }, [
                            _createElementVNode("td", _hoisted_37, [
                              _createVNode(_component_v_icon, {
                                size: "14",
                                class: "mr-1 sigungu-icon"
                              }, {
                                default: _withCtx(() => [...(_cache[32] || (_cache[32] = [
                                  _createTextVNode("mdi-map-marker-outline", -1)
                                ]))]),
                                _: 1
                              }),
                              _createElementVNode("span", _hoisted_38, _toDisplayString(sg.sigungu_name), 1)
                            ]),
                            _createElementVNode("td", _hoisted_39, [
                              _createElementVNode("span", _hoisted_40, _toDisplayString(sg.total_count?.toLocaleString()), 1),
                              _createElementVNode("span", _hoisted_41, _toDisplayString(getSharePct(sg.total_count, region.total_count)), 1)
                            ]),
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(visibleBizTypes.value, (biz) => {
                              return (_openBlock(), _createElementBlock("td", {
                                key: `${sg.sigungu_code}-${biz.short}`,
                                class: _normalizeClass(["col-biz num-cell", { highlighted: selectedBiz.value === biz.short, dimmed: selectedBiz.value && selectedBiz.value !== biz.short, 'has-value': sg.biz?.[biz.short] }])
                              }, [
                                _createElementVNode("span", _hoisted_42, _toDisplayString(formatBizCount(sg.biz?.[biz.short])), 1),
                                (sg.biz?.[biz.short])
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_43, _toDisplayString(getSharePct(sg.biz[biz.short], sg.total_count)), 1))
                                  : _createCommentVNode("", true)
                              ], 2))
                            }), 128))
                          ], 8, _hoisted_36)), [
                            [_vShow, expandedSido.value === region.sido_code]
                          ])
                        }), 128))
                      ], 64))
                    }), 128)),
                    (!stats.value.byRegion?.length)
                      ? (_openBlock(), _createElementBlock("tr", _hoisted_44, [
                          _createElementVNode("td", {
                            colspan: visibleBizTypes.value.length + 2
                          }, "수집된 기관 데이터가 없습니다.", 8, _hoisted_45)
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  (stats.value.byRegion?.length)
                    ? (_openBlock(), _createElementBlock("tfoot", _hoisted_46, [
                        _createElementVNode("tr", _hoisted_47, [
                          _cache[33] || (_cache[33] = _createElementVNode("td", { class: "col-region sticky-col" }, "전국 합계", -1)),
                          _createElementVNode("td", _hoisted_48, [
                            _createElementVNode("span", _hoisted_49, _toDisplayString(stats.value.summary?.total_count?.toLocaleString() || 0), 1)
                          ]),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(visibleBizTypes.value, (biz) => {
                            return (_openBlock(), _createElementBlock("td", {
                              key: `total-${biz.short}`,
                              class: _normalizeClass(["col-biz num-cell", { highlighted: selectedBiz.value === biz.short, 'has-value': getBizTotal(biz.short) }])
                            }, [
                              _createElementVNode("span", _hoisted_50, _toDisplayString(formatBizCount(getBizTotal(biz.short))), 1)
                            ], 2))
                          }), 128))
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ])
              ])
            ])
          ])
        ]),
        _createVNode(CrawlExcelDownloadDialog, {
          modelValue: excelDialogOpen.value,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((excelDialogOpen).value = $event))
        }, null, 8, ["modelValue"]),
        _createVNode(_component_v_dialog, {
          modelValue: crawlerGuideDialog.value,
          "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((crawlerGuideDialog).value = $event)),
          "max-width": "720"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_card, { class: "pc-crawler-guide-modal" }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_51, [
                  _createVNode(_component_v_icon, {
                    size: "24",
                    class: "mr-2"
                  }, {
                    default: _withCtx(() => [...(_cache[34] || (_cache[34] = [
                      _createTextVNode("mdi-nodejs", -1)
                    ]))]),
                    _: 1
                  }),
                  _cache[36] || (_cache[36] = _createElementVNode("h3", null, "PC 크롤러", -1)),
                  _createVNode(_component_v_spacer),
                  _createVNode(_component_v_btn, {
                    icon: "",
                    variant: "text",
                    onClick: _cache[4] || (_cache[4] = ($event: any) => (crawlerGuideDialog.value = false))
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_icon, null, {
                        default: _withCtx(() => [...(_cache[35] || (_cache[35] = [
                          _createTextVNode("mdi-close", -1)
                        ]))]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("div", _hoisted_52, [
                  _createElementVNode("div", _hoisted_53, [
                    _createElementVNode("div", _hoisted_54, [
                      _createVNode(_component_v_icon, {
                        size: "20",
                        class: "mr-2"
                      }, {
                        default: _withCtx(() => [...(_cache[37] || (_cache[37] = [
                          _createTextVNode("mdi-console", -1)
                        ]))]),
                        _: 1
                      }),
                      _cache[38] || (_cache[38] = _createTextVNode(" 실행 방법 ", -1))
                    ]),
                    _cache[52] || (_cache[52] = _createElementVNode("div", { class: "builder-desc" }, [
                      _createTextVNode(" zip을 풀고 "),
                      _createElementVNode("strong", null, "실행.bat"),
                      _createTextVNode(" 을 더블클릭하면 됩니다. Node.js 설치는 필요 없습니다. 브라우저 창 "),
                      _createElementVNode("strong", null, "1개"),
                      _createTextVNode("가 화면 상단에 열리고, 아래 창에 진행이 나옵니다. 전국을 "),
                      _createElementVNode("strong", null, "한 바퀴"),
                      _createTextVNode(" 돈 뒤 끝납니다. 최근 일주일 안에 받은 기관은 건너뛰고, 중간에 꺼도 다음에 다시 실행하면 이어서 수집합니다. 브라우저 창은 닫지 마세요. ")
                    ], -1)),
                    _createElementVNode("div", _hoisted_55, [
                      _createElementVNode("div", _hoisted_56, [
                        _createElementVNode("span", _hoisted_57, [
                          _createVNode(_component_v_icon, {
                            size: "16",
                            class: "mr-1"
                          }, {
                            default: _withCtx(() => [...(_cache[39] || (_cache[39] = [
                              _createTextVNode("mdi-mouse", -1)
                            ]))]),
                            _: 1
                          }),
                          _cache[40] || (_cache[40] = _createTextVNode(" 실행 ", -1))
                        ]),
                        _cache[41] || (_cache[41] = _createElementVNode("span", { class: "target-region" }, "전국 한 바퀴 · 최근 일주일은 건너뜀 · 이어서 수집", -1))
                      ]),
                      _createElementVNode("div", _hoisted_58, [
                        _cache[44] || (_cache[44] = _createElementVNode("code", null, "실행.bat", -1)),
                        _createVNode(_component_v_btn, {
                          variant: "flat",
                          size: "small",
                          class: "copy-btn",
                          onClick: _cache[5] || (_cache[5] = ($event: any) => (copyCommand('실행.bat')))
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_icon, {
                              size: "16",
                              class: "mr-1"
                            }, {
                              default: _withCtx(() => [...(_cache[42] || (_cache[42] = [
                                _createTextVNode("mdi-content-copy", -1)
                              ]))]),
                              _: 1
                            }),
                            _cache[43] || (_cache[43] = _createTextVNode(" 복사 ", -1))
                          ]),
                          _: 1
                        })
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_59, [
                      _createVNode(_component_v_icon, {
                        size: "14",
                        class: "mr-1"
                      }, {
                        default: _withCtx(() => [...(_cache[45] || (_cache[45] = [
                          _createTextVNode("mdi-information-outline", -1)
                        ]))]),
                        _: 1
                      }),
                      _cache[46] || (_cache[46] = _createTextVNode(" CMD 하단에 ", -1)),
                      _cache[47] || (_cache[47] = _createElementVNode("code", null, "[바퀴][I#][시도][시군구] N/M 저장 · 소요시간", -1)),
                      _cache[48] || (_cache[48] = _createTextVNode(" 요약이 출력됩니다. ", -1))
                    ]),
                    _createElementVNode("div", _hoisted_60, [
                      _createElementVNode("div", _hoisted_61, [
                        _createVNode(_component_v_icon, {
                          size: "16",
                          class: "mr-1"
                        }, {
                          default: _withCtx(() => [...(_cache[49] || (_cache[49] = [
                            _createTextVNode("mdi-book-open-page-variant", -1)
                          ]))]),
                          _: 1
                        }),
                        _cache[50] || (_cache[50] = _createTextVNode(" 명령어 ", -1))
                      ]),
                      (_openBlock(), _createElementBlock(_Fragment, null, _renderList(commandExamples, (ex, idx) => {
                        return _createElementVNode("div", {
                          key: idx,
                          class: "example-row"
                        }, [
                          _createElementVNode("div", _hoisted_62, [
                            _createElementVNode("code", null, _toDisplayString(ex.cmd), 1),
                            _createVNode(_component_v_btn, {
                              variant: "text",
                              size: "x-small",
                              class: "example-copy",
                              onClick: ($event: any) => (copyCommand(ex.cmd))
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_icon, { size: "14" }, {
                                  default: _withCtx(() => [...(_cache[51] || (_cache[51] = [
                                    _createTextVNode("mdi-content-copy", -1)
                                  ]))]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }, 8, ["onClick"])
                          ]),
                          _createElementVNode("div", _hoisted_63, _toDisplayString(ex.desc), 1)
                        ])
                      }), 64))
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_64, [
                    _createElementVNode("div", {
                      class: "guide-toggle",
                      onClick: _cache[6] || (_cache[6] = ($event: any) => (showInstallGuide.value = !showInstallGuide.value))
                    }, [
                      _createVNode(_component_v_icon, {
                        size: "18",
                        class: "mr-2"
                      }, {
                        default: _withCtx(() => [...(_cache[53] || (_cache[53] = [
                          _createTextVNode("mdi-help-circle-outline", -1)
                        ]))]),
                        _: 1
                      }),
                      _cache[54] || (_cache[54] = _createTextVNode(" 처음 사용하시나요? 설치 가이드 보기 ", -1)),
                      _createVNode(_component_v_spacer),
                      _createVNode(_component_v_icon, { size: "20" }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(showInstallGuide.value ? 'mdi-chevron-up' : 'mdi-chevron-down'), 1)
                        ]),
                        _: 1
                      })
                    ]),
                    _createVNode(_component_v_expand_transition, null, {
                      default: _withCtx(() => [
                        _withDirectives(_createElementVNode("div", _hoisted_65, [
                          _cache[60] || (_cache[60] = _createElementVNode("div", { class: "guide-step" }, [
                            _createElementVNode("div", { class: "step-num" }, "1"),
                            _createElementVNode("div", { class: "step-info" }, [
                              _createElementVNode("div", { class: "step-title" }, "PC 크롤러 다운로드"),
                              _createElementVNode("div", { class: "step-desc" }, "위쪽 「PC 크롤러」 버튼으로 zip을 받습니다.")
                            ])
                          ], -1)),
                          _cache[61] || (_cache[61] = _createElementVNode("div", { class: "guide-step" }, [
                            _createElementVNode("div", { class: "step-num" }, "2"),
                            _createElementVNode("div", { class: "step-info" }, [
                              _createElementVNode("div", { class: "step-title" }, "압축 해제"),
                              _createElementVNode("div", { class: "step-desc" }, "원하는 폴더에 zip을 풉니다. Node.js는 따로 설치하지 않습니다.")
                            ])
                          ], -1)),
                          _createElementVNode("div", _hoisted_66, [
                            _cache[59] || (_cache[59] = _createElementVNode("div", { class: "step-num" }, "3", -1)),
                            _createElementVNode("div", _hoisted_67, [
                              _cache[58] || (_cache[58] = _createElementVNode("div", { class: "step-title" }, "실행", -1)),
                              _createElementVNode("div", _hoisted_68, [
                                _createElementVNode("div", _hoisted_69, [
                                  _cache[56] || (_cache[56] = _createElementVNode("code", null, "실행.bat", -1)),
                                  _createElementVNode("button", {
                                    class: "mini-copy",
                                    onClick: _cache[7] || (_cache[7] = ($event: any) => (copyCommand('실행.bat')))
                                  }, [
                                    _createVNode(_component_v_icon, { size: "12" }, {
                                      default: _withCtx(() => [...(_cache[55] || (_cache[55] = [
                                        _createTextVNode("mdi-content-copy", -1)
                                      ]))]),
                                      _: 1
                                    })
                                  ])
                                ]),
                                _cache[57] || (_cache[57] = _createTextVNode(" 더블클릭하면 수집이 시작됩니다. 창을 닫지 마세요. ", -1))
                              ])
                            ])
                          ])
                        ], 512), [
                          [_vShow, showInstallGuide.value]
                        ])
                      ]),
                      _: 1
                    })
                  ])
                ]),
                _createElementVNode("div", _hoisted_70, [
                  _createVNode(_component_v_icon, {
                    size: "16",
                    class: "mr-1"
                  }, {
                    default: _withCtx(() => [...(_cache[62] || (_cache[62] = [
                      _createTextVNode("mdi-information-outline", -1)
                    ]))]),
                    _: 1
                  }),
                  _cache[63] || (_cache[63] = _createTextVNode(" 크롤링 결과는 서버로 자동 전송되며, ", -1)),
                  _cache[64] || (_cache[64] = _createElementVNode("code", null, "output", -1)),
                  _cache[65] || (_cache[65] = _createTextVNode(" 폴더에 JSON 백업도 저장됩니다. ", -1))
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["modelValue"])
      ])
    ])
  ]))
}
}

})